// Module
var code = "<template> </template>";
// Exports
export default code;